function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import Axios from 'axios-observable';
import { AppTypes, InjectableConfig } from '../enums';
import { WindowedObservable } from '../windowed-observable';
export var BaseConfigService = /*#__PURE__*/ function() {
    "use strict";
    function BaseConfigService(config) {
        _class_call_check(this, BaseConfigService);
        _define_property(this, "appType", new WindowedObservable(InjectableConfig.AppType).getLastEvent());
        _define_property(this, "mfeType", new WindowedObservable(InjectableConfig.MfeType).getLastEvent());
        _define_property(this, "axiosConfig", void 0);
        _define_property(this, "fboAxiosConfig", void 0);
        _define_property(this, "environmentConfig", void 0);
        _define_property(this, "rollbarConfig", null);
        this.initializeEnv(config === null || config === void 0 ? void 0 : config.envKey);
        this.initializeAxios(config === null || config === void 0 ? void 0 : config.axiosKey);
        if (config === null || config === void 0 ? void 0 : config.fboAxiosKey) {
            this.initializeFboAxios(config.fboAxiosKey);
        }
    }
    _create_class(BaseConfigService, [
        {
            key: "rollbar",
            get: function get() {
                if (!this.rollbarConfig) {
                    this.rollbarConfig = new WindowedObservable(InjectableConfig.Rollbar).getLastEvent();
                }
                return this.rollbarConfig;
            }
        },
        {
            key: "fboAxios",
            get: function get() {
                return this.fboAxiosConfig;
            }
        },
        {
            key: "axios",
            get: function get() {
                return this.axiosConfig;
            }
        },
        {
            key: "environment",
            get: function get() {
                return this.environmentConfig;
            }
        },
        {
            key: "isClientApp",
            get: function get() {
                return this.appType === AppTypes.client;
            }
        },
        {
            key: "isResumeApp",
            get: function get() {
                return this.appType === AppTypes.resume;
            }
        },
        {
            key: "isSubmissionApp",
            get: function get() {
                return this.appType === AppTypes.submission;
            }
        },
        {
            key: "initializeAxios",
            value: function initializeAxios() {
                var configKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : InjectableConfig.Axios;
                var config$ = new WindowedObservable(configKey);
                this.axiosConfig = config$.getLastEvent();
                if (!this.axiosConfig) {
                    if (this.appType && !this.mfeType) {
                        throw new Error("".concat(configKey, " should be published explicitly"));
                    }
                    this.axiosConfig = Axios.create({});
                    config$.publish(this.axiosConfig);
                }
            }
        },
        {
            key: "initializeFboAxios",
            value: function initializeFboAxios(configKey) {
                var config$ = new WindowedObservable(configKey);
                this.fboAxiosConfig = config$.getLastEvent();
                if (!this.fboAxiosConfig) {
                    if (this.appType && !this.mfeType) {
                        throw new Error("".concat(configKey, " should be published explicitly"));
                    }
                    this.fboAxiosConfig = Axios.create({});
                    config$.publish(this.fboAxiosConfig);
                }
            }
        },
        {
            key: "initializeEnv",
            value: function initializeEnv() {
                var configKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : InjectableConfig.Environment;
                this.environmentConfig = new WindowedObservable(configKey).getLastEvent();
            }
        }
    ]);
    return BaseConfigService;
}();
